// src/components/backgrounds/WaveBackground.jsx
import React from "react";
import "../style/WaveBackground.css"; // we'll add simple CSS for animation

export default function WaveBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden z-0">
      <svg
        className="absolute bottom-0 left-0 h-40 md:h-56 lg:h-72"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          className="wave wave1"
          fill="#60A5FA" // Tailwind blue-400
          fillOpacity="0.4"
          d="M0,160L48,176C96,192,192,224,288,208C384,192,480,128,576,122.7C672,117,768,171,864,186.7C960,203,1056,181,1152,165.3C1248,149,1344,139,1392,133.3L1440,128L1440,320L0,320Z"
        ></path>
        <path
          className="wave wave2"
          fill="#3B82F6" // Tailwind blue-500
          fillOpacity="0.6"
          d="M0,160L48,176C96,192,192,224,288,208C384,192,480,128,576,122.7C672,117,768,171,864,186.7C960,203,1056,181,1152,165.3C1248,149,1344,139,1392,133.3L1440,128L1440,320L0,320Z"
        ></path>
        <path
          className="wave wave3"
          fill="#1D4ED8" // Tailwind blue-700
          fillOpacity="0.4"
          d="M0,160L48,176C96,192,192,224,288,208C384,192,480,128,576,122.7C672,117,768,171,864,186.7C960,203,1056,181,1152,165.3C1248,149,1344,139,1392,133.3L1440,128L1440,320L0,320Z"
        ></path>
      </svg>
    </div>
  );
}
